export const AUTO_GOAL_CREATION_WIZARD_STEP_PATHS = {
  GOAL_TYPE_SELECTION: 'GOAL_TYPE_SELECTION',
  WEBSITE: 'WEBSITE',
  GOAL_DETAIL_SETTING: 'GOAL_DETAIL_SETTING',
  UET_SETUP: 'UET_SETUP',
  DONE: 'DONE',
  MANUAL: 'MANUAL',
};

export const FLOWS = {
  MANUAL_GOAL: 'MANUAL_GOAL',
  MANUAL_GOAL_WEBSITE: 'MANUAL_GOAL_WEBSITE',
  AUTO_GOAL_WITH_UET: 'AUTO_GOAL_WITH_UET',
  AUTO_GOAL_WITHOUT_UET: 'AUTO_GOAL_WITHOUT_UET',
  AUTO_GOAL_SKIP_WEBSITE_WITH_UET: 'AUTO_GOAL_SKIP_WEBSITE_WITH_UET',
  AUTO_GOAL_SKIP_WEBSITE_WITHOUT_UET: 'AUTO_GOAL_SKIP_WEBSITE_WITHOUT_UET',
};

export const stepToPage = {
  [AUTO_GOAL_CREATION_WIZARD_STEP_PATHS.GOAL_TYPE_SELECTION]: 'autogoalwizard010.goalTypeSelection',
  [AUTO_GOAL_CREATION_WIZARD_STEP_PATHS.WEBSITE]: 'autogoalwizard020.website',
  [AUTO_GOAL_CREATION_WIZARD_STEP_PATHS.GOAL_DETAIL_SETTING]: 'autogoalwizard030.goaldetail',
  [AUTO_GOAL_CREATION_WIZARD_STEP_PATHS.UET_SETUP]: 'autogoalwizard040.uetsetup',
  [AUTO_GOAL_CREATION_WIZARD_STEP_PATHS.DONE]: 'autogoalwizard050.done',
  [AUTO_GOAL_CREATION_WIZARD_STEP_PATHS.MANUAL]: 'autogoalwizard000.manual',
};
